import { IProfessionalQualificationAttribute } from '@medely/types';
import { QueryFunctionContext, useQuery } from '@tanstack/react-query';
import { GET_PROFESSIONAL_QUALIFICATION_ATTRIBUTE } from '@mp';
import useGraphQLRequest from './useGraphQLRequest';

type GraphQLResponse = {
  professionalQualificationAttribute: IProfessionalQualificationAttribute;
};

const useProfessionalQualificationAttribute = (id: number) => {
  const { request } = useGraphQLRequest<GraphQLResponse>();

  const fetchProfessionalQualificationAttribute = async ({
    queryKey: [_entity, id],
  }: QueryFunctionContext<[unknown, number]>): Promise<IProfessionalQualificationAttribute> => {
    const { professionalQualificationAttribute } = await request(
      GET_PROFESSIONAL_QUALIFICATION_ATTRIBUTE,
      { id },
    );
    return professionalQualificationAttribute;
  };

  const { data, isLoading } = useQuery(
    ['professionalQualificationAttribute', id],
    fetchProfessionalQualificationAttribute,
    { enabled: !!id },
  );

  return { data, isLoading };
};

export default useProfessionalQualificationAttribute;
